import { InternalLogMessage, LogLevel, LogTransport } from '../../types.js';

export abstract class BatchLogTransport implements LogTransport {
  queue: Array<[LogLevel, InternalLogMessage]> = [];
  queuePromise: Promise<void> | null = null;
  timeoutHandle: ReturnType<typeof setTimeout> | null = null;

  constructor(private timeout: number) {}

  abstract logBatch(logs: Array<[LogLevel, InternalLogMessage]>): Promise<void>;

  flushSync() {
    const payloads = this.queue;
    this.queue = [];
    this.timeoutHandle = null;
    // Make sure the previous flush has completed before going again
    const queuePromise = this.queuePromise ?? Promise.resolve();
    this.queuePromise = queuePromise.finally(async () => {
      await this.logBatch(payloads);
    });
  }

  async flush(): Promise<void> {
    this.flushSync();
    await this.queuePromise;
  }

  log(level: LogLevel, message: InternalLogMessage): void {
    this.queue.push([level, message]);
    if (this.timeoutHandle == null) {
      this.timeoutHandle = setTimeout(() => this.flush(), this.timeout);
    }
  }
}
